import { render, staticRenderFns } from "./Screensaver.vue?vue&type=template&id=a284222e"
import script from "./Screensaver.vue?vue&type=script&lang=ts"
export * from "./Screensaver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports